import { createSelector } from 'reselect';

export const isLoading = createSelector(
  (state) => state.Dashboard.loading,
  (dashboard) => dashboard,
);
